export class Invites {
    email:string;
    isAttending:number=-1;
    reason:string=null;
}


// WEBPACK FOOTER //
// /app/src/app/core/models/invites.ts